module.exports = __webpack_public_path__ + "static/media/node.b73453c6.png";